import { CHANNEL_TYPES } from "@/common/constants/channel";
export const CHANNEL_CONFIG = [
  {
    type: '频道',
    key: 'default',
    data: [
      {
        title: '频道概况',
        key: 'channel-info',
        componentName: 'channel-info'
      },
      {
        title: '成员权限',
        key: 'channel-role-manage',
        componentName: 'channel-role-manage',
        hiddenChannelType: [CHANNEL_TYPES.temporary_group, CHANNEL_TYPES.temporary, CHANNEL_TYPES.custom] // 临时频道和自定义频道不能设置成员权限
      },
      {
        title: '邀请管理',
        key: 'channel-invite-manage',
        componentName: 'channel-invite-manage',
        requirePermissions: ['RoomManager'],
        hiddenChannelType: [CHANNEL_TYPES.temporary_group, CHANNEL_TYPES.temporary] // 临时频道不能查看邀请管理
      },
    ]
  },
];

export const GROUP_CONFIG = [
  {
    type: '分组',
    key: 'default',
    data: [
      {
        title: '分组概况',
        key: 'group-info',
        componentName: 'group-info'
      },
      {
        title: '成员权限',
        key: 'channel-role-manage',
        componentName: 'channel-role-manage'
      },
    ]
  },
];

export const SLOW_MODE_CONFIG = [{
  value: 0,
  label: '关',
}, {
  value: 1,
  label: '5秒',
  second: 5,
}, {
  value: 2,
  label: '10秒',
  second: 10,
}, {
  value: 3,
  label: '15秒',
  second: 15,
}, {
  value: 4,
  label: '30秒',
  second: 30,
}, {
  value: 5,
  label: '1分钟',
  second: 60,
}, {
  value: 6,
  label: '2分钟',
  second: 60 * 2,
}, {
  value: 7,
  label: '5分钟',
  second: 60 * 5,
}, {
  value: 8,
  label: '10分钟',
  second: 60 * 10,
}, {
  value: 9,
  label: '15分钟',
  second: 60 * 15,
}, {
  value: 10,
  label: '30分钟',
  second: 60 * 30,
}, {
  value: 11,
  label: '1小时',
  second: 60 * 60,
}, {
  value: 12,
  label: '2小时',
  second: 60 * 60 * 2,
}, {
  value: 13,
  label: '6小时',
  second: 60 * 60 * 6,
}];

export const CHANNEL_FOLLOW_GROUP = {
  FOLLOW: 0,
  UNFOLLOW: 1,
}

// 二进制数据的位置映射
export const BINARY_POS_MAP = {
  'max_count': 0,
  'audio_bitrate': 1,
  'slow_mode': 2,
  'api_type': 3,
}